import Table from 'antd/es/table';
import styled from 'styled-components';
import { Row, Col, Skeleton } from 'antd';

export const RiskLevel = styled.div`
	width: 127px;
	height: 32px;
	padding: 8px;
	border-radius: 4px;
	text-align: center;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
`;


export const TaskTitle = styled.p`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
`;

export const StyledTable = styled(Table)`
	.ant-table-thead > tr > th {
		gap: 10px;
		height: 56px;
		padding: 8px;
		text-align: center;
		align-items: center;
		justify-content: center;
		font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
		font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
		letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};

		&::before {
			display: none !important;
		}
	}

	.ant-table-thead > tr:first-child > th {
		background-color: #2F54EB !important;
		color: ${({ theme }) => theme.palette.secondary.white};
		border-bottom: none;
		border-right: 1px solid ${({ theme }) => theme.palette.secondary['100']};

		&:last-child {
			border-right: none;
		}

		&:first-child {
			border-top-left-radius: 8px;
		}

		&:last-child {
			border-top-right-radius: 8px;
		}
	}

	.ant-table-thead > tr:nth-child(2) > th {
		background-color: ${({ theme }) => theme.palette.secondary['100']} !important;
		border-bottom: 2px solid ${({ theme }) => theme.palette.secondary.white};
		border-right: 1px solid ${({ theme }) => theme.palette.secondary.white};

		&:last-child {
			border-right: none;
		}
	}

	.ant-table-cell {
		font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
		letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
		font-weight: ${({ theme }) => theme.sizes.weights.regular};
		background-color: ${({ theme }) => theme.palette.secondary['50']} !important;
		border-bottom: 2px solid ${({ theme }) => theme.palette.secondary.white};
		text-align: center;
	}

	.ant-table-tbody > tr > td {
		> div {
			margin: 0 auto;
		}
	}

	.ant-table-tbody > tr > td:not(:last-child) {
		border-right: 1px solid ${({ theme }) => theme.palette.secondary.white};
	}

	.hidden-xs {
		@media (max-width: 1400px) {
			display: none !important;
		}
	}

	.visible-xs {
		display: none;
		@media (max-width: 1400px) {
			display: block !important;
		}
	}

	.ant-table-container {
		overflow: auto;
	}
`;

export const CreateButton = styled.button`
	width: 149px;
	height: 32px;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.regular};
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	border: 1px solid ${({ theme }) => theme.palette.secondary['150']};
	background-color: ${({ theme }) => theme.palette.secondary.white};
	padding: 8px;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background-color: #f5f5f5;
		border-color: ${({ theme }) => theme.palette.secondary['200']};
	}

	&:active {
		background-color: ${({ theme }) => theme.palette.secondary['150']};
	}
`;

export const SkeletonContainer = styled.div`
	padding: 16px;
`;

export const SkeletonRow = styled(Row)`
	margin-bottom: 12px;
`;

export const SkeletonCol = styled(Col)`
	display: flex;
	justify-content: center;
`;

export const SkeletonInput = styled(Skeleton.Input)`
	width: 30%;
	height: 32px;
`;

export const SkeletonInputWide = styled(Skeleton.Input)`
	width: 50%;
	height: 32px;
`;

export const TaskTitleContainer = styled.div`
	margin-bottom: 16px;
`;

export const TaskTitleWrapper = styled.div`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 150px;
	margin: 0 auto;
`;
